import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent, IconName } from '../../icon/icon.component';

/** One link of the flyout: the sidebar's own nav item, shown with its icon and label. */
export interface SidebarFlyoutItem {
  path: string;
  labelKey: string;
  icon: IconName;
  /** Active only on this exact path. */
  exact?: boolean;
}

/**
 * The panel the collapsed rail opens beside a group's icon: the group's title and its links (the rail itself shows one icon per group).
 * Display only: the sidebar decides when it is open and where it sits (`top` and `start`, in pixels from the top and from the start edge of the window,
 * so it opens toward the content in left-to-right and right-to-left), and closes it when `linkClick` is emitted.
 */
@Component({
  selector: 'app-sidebar-flyout',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslatePipe, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.top.px]': 'top()', '[style.inset-inline-start.px]': 'start()' },
  templateUrl: './sidebar-flyout.component.html',
  styleUrl: './sidebar-flyout.component.scss',
})
export class SidebarFlyoutComponent {
  /** The translation key of the group's name. */
  readonly title = input.required<string>();
  readonly items = input.required<readonly SidebarFlyoutItem[]>();
  readonly top = input(0);
  readonly start = input(0);
  readonly linkClick = output<void>();
}
